import React from 'react'
import PropTypes from 'prop-types'
import { useFormField } from 'sb-hooks'


const FieldState = ({ children, field }) => {
  const fieldState = useFormField(field)

  return children(fieldState)
}

FieldState.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
}


export default FieldState
